<template>
  <modal name="modal-add-job-request" height="auto" :width="560"
         :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>NEW JOB REQUEST</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <div v-if="state == 'added'" class="text-center m-3">
      <p style="font-size: 18px;">Thank you! Someone from the<br/>team will be in touch soon.</p>
    </div>
    <form v-else method="post" @submit.prevent="doCreate">
      <div class="form-row">
        <label class="lb min-w-100">DATE <span class="text-danger">*</span></label>
        <div class="inputs">
          <date-picker format="DD/MM/YYYY" value-type="YYYY-MM-DD" v-model="postData.request_date" name="request_date" :editable="false" v-validate.disable="{ required: true }"
                       input-class="form-control" style="display: block;width: 100%;"></date-picker>
        </div>
        <div class="invalid-feedback">{{ errors.first('request_date') }}</div>
      </div>
      <div class="form-row">
        <label class="lb min-w-100">COMPANY <span class="text-danger">*</span></label>
        <div class="inputs">
          <div v-if="IS_CLIENT" type="text" class="form-control">{{ CURRENT_USER.client.name }}</div>
          <div v-else>
            <v-select id="client_id" v-model="postData.client_id" :options="allClients" class="form-control" :reduce="item => item.id"
                      label="name" :searchable="true" :placeholder="'- Select company'"></v-select>
          </div>
        </div>
      </div>
      <div class="form-row">
        <label class="lb min-w-100">CONTACT <span class="text-danger">*</span></label>
        <div class="inputs">
          <v-select v-model="postData.contact_id" :options="clientContacts" class="form-control" :reduce="item => item.id"
                    label="full_name" :searchable="true" :clearable="true" :placeholder="'- Select contact'"></v-select>
        </div>
      </div>
      <div class="form-row">
        <label class="lb min-w-100">JOB NAME <span class="text-danger">*</span></label>
        <div class="inputs">
          <input type="text" name="name" id="name" ref="inputName"
                 :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                 v-validate.disable="{ required: true }"
                 v-model="postData.name">
        </div>
        <div class="invalid-feedback">{{ errors.first('name') }}</div>
      </div>
      <div class="form-row">
        <label class="lb min-w-100">DESCRIPTION <span class="text-danger">*</span></label>
        <div class="inputs">
          <textarea id="description" name="description" class="form-control" rows="6"
                    :class="{'form-control': true, 'is-invalid': errors.has('description')}"
                    v-validate.disable="{ required: true }"
                    v-model="postData.description"></textarea>
        </div>
        <div class="invalid-feedback">{{ errors.first('description') }}</div>
      </div>
      <div class="form-group">
        <label>FILE ATTACHMENTS (pdf, jpgs , png, zip, doc, xls)</label>
        <vue-dropzone ref="documentUploader" id="documentUploader" v-show="true"
                      :include-styling="true" :options="dzOptions"
                      :use-custom-slot="true"
                      @vdropzone-sending="onSending"
                      @vdropzone-success-multiple="onUploaded">
          <button type="button" class="btn btn-outline-info"><i class="fa fa-folder"></i> Browse Files</button>
        </vue-dropzone>
      </div>
      <div class="pt-2 btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button type="submit" class="btn btn-outline-black mr-2">Submit</button>
          <button type="button" class="btn btn-outline-secondary" @click="closeModal">Cancel</button>
        </template>
      </div>
    </form>
  </modal>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import dayjs from 'dayjs'
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import ServiceClient from '@/services/client'
  import DatePicker from 'vue2-datepicker';
  import vue2Dropzone from 'vue2-dropzone'
  import ServiceJobRequest from '@/services/jobrequest'

  export default {
    components: {
      BeatLoader,
      DatePicker,
      vueDropzone: vue2Dropzone
    },
    data () {
      return {
        state: '',
        postData: {
          request_date: '',
          client_id: '',
          contact_id: '',
          name: '',
          description: ''
        },
        clientContacts: [],
        dzOptions: {
          url: process.env.VUE_APP_APIURL + 'job-requests',
          headers: {
            'Authorization': 'Bearer ' + this.$localStorage.get('access_token'),
          },
          paramName: 'file',
          createImageThumbnails: false,
          autoProcessQueue: false,
          maxFiles: 1000,
          uploadMultiple: true,
          parallelUploads: 1000,
          addRemoveLinks: true,
          timeout: 100000,
          acceptedFiles: 'image/*,application/pdf,.zip,.doc,.docx,.xls,.xlsx'
        }
      }
    },
    props: ['value'],
    computed: {
      ...mapGetters(['CURRENT_USER', 'IS_CLIENT']),
      ...mapState({
        allClients: state => state.option.clients,
      })
    },
    watch: {
      value ( newVal ) {
        if ( newVal ) {
          this.$modal.show('modal-add-job-request', {});
        }
      },
      'postData.client_id': function (newVal) {
        this.getContacts(newVal);
      }
    },
    mounted () {
      let self = this;
      self.init();
    },
    methods: {
      resetForm () {
        let self = this, now = new Date();
        self.postData = {
          request_date: '',
          client_id: '',
          contact_id: '',
          name: '',
          description: ''
        };
        self.postData.request_date = dayjs(now).format('YYYY-MM-DD');
        if (typeof self.CURRENT_USER.client_id != "undefined") {
          self.getContacts(self.CURRENT_USER.client_id);
          self.postData.client_id = self.CURRENT_USER.client_id;
        }
      },
      init () {
        this.resetForm();
      },
      closeModal () {
        this.resetForm();
        this.$emit('close');
        this.$modal.hide('modal-add-job-request');
        this.state = '';
      },
      doCreate ( ) {
        let self = this;
        if (self.state == 'saving') {
          return;
        }

        self.$validator.validateAll()
          .then(ok => {
            if ( ok ) {
              if(!self.postData.contact_id) {
                self.$notify({
                  type: 'error',
                  text: 'Please select the contact'
                });
                return false;
              }
              self.state = 'saving';
              let queuedFiles = self.$refs.documentUploader.getQueuedFiles();
              if (queuedFiles.length > 0)
                self.$refs.documentUploader.processQueue();
              else {
                ServiceJobRequest.create(self.postData, function () {
                  self.state = 'added';
                  self.state = '';
                  self.$notify({
                    type: 'success',
                    text: 'Request submitted successfully.'
                  });
                  self.resetForm();
                  self.$emit('request-submitted');
                  self.closeModal();
                }, function (error) {
                  self.$notify({
                    type: 'error',
                    text: error
                  });
                  self.state = '';
                });
              }
            }
          });
      },
      getContacts (clientId) {
        if (clientId) {
          let self = this;
          ServiceClient.getMembers(clientId, {ipp: 'all'}, resp => {
            self.clientContacts = resp;
          });
        } else {
          self.clientContacts = [];
        }

      },
      onSending (file, xhr, formData) {
        let self = this;
        if (self.postData) {
          for(let f in self.postData) {
            formData.append(f, self.postData[f]);
          }
        }
      },
      onUploaded ( file, resp ) {
        let self = this;
        self.state = '';
        if ( resp.status == 'SUCCESS' ) {
          self.state = '';
          self.$notify({
            type: 'success',
            text: 'Request submitted successfully.'
          });
          self.resetForm();
          self.$emit('request-submitted');
          self.closeModal();
        }
        else {
          self.$notify({
            type: 'error',
            text: resp.error
          });
        }
      },
    }
  }
</script>
